import React, { useEffect, useState } from 'react';
import {
  hasRecoverablePlatformAdminSession,
  loginPlatformAdmin,
  restorePlatformAdminSession
} from '../services/platformAdminClient';
import '../styles/PlatformOwnerLogin.css';

function navigateToPanel(onAuthenticated, actor) {
  if (typeof onAuthenticated === 'function') {
    onAuthenticated(actor);
    return;
  }
  window.location.assign('/owner');
}

export default function PlatformOwnerLogin({ onAuthenticated, initialEmail = '' }) {
  const [email, setEmail] = useState(initialEmail);
  const [password, setPassword] = useState('');
  const [checking, setChecking] = useState(hasRecoverablePlatformAdminSession());
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!checking) return undefined;
    let active = true;
    restorePlatformAdminSession()
      .then((actor) => { if (active && actor) navigateToPanel(onAuthenticated, actor); })
      .catch((restoreError) => {
        if (active && restoreError?.code === 'network_unavailable') setError(restoreError.message);
      })
      .finally(() => { if (active) setChecking(false); });
    return () => { active = false; };
  }, [checking, onAuthenticated]);

  const submit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError('');
    try {
      const actor = await loginPlatformAdmin({ email, password });
      setPassword('');
      navigateToPanel(onAuthenticated, actor);
    } catch (loginError) {
      setError(loginError?.message || 'Não foi possível entrar na central Help Seller.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="platform-login-page">
      <section className="platform-login-context">
        <a className="platform-login-brand" href="https://helpseller.com.br">
          <span><i className="fas fa-layer-group" aria-hidden="true" /></span>
          <strong>Help Seller</strong>
        </a>
        <div>
          <span className="platform-login-eyebrow">Control plane · uso interno</span>
          <h1>A operação dos clientes em uma central separada.</h1>
          <p>Carteira do ERP, licenças, assinaturas e suporte — sem misturar dados administrativos com o ambiente de cada lojista.</p>
        </div>
        <small><i className="fas fa-shield-halved" aria-hidden="true" /> Acesso monitorado e exclusivo da equipe Help Seller.</small>
      </section>

      <main className="platform-login-form-shell">
        <section className="platform-login-card">
          <span className="platform-login-eyebrow">Central administrativa</span>
          <h2>Entrar como owner</h2>
          <p>Este não é o login do ERP dos lojistas.</p>
          {checking ? (
            <div className="platform-login-loading" role="status"><i className="fas fa-spinner fa-spin" aria-hidden="true" /> Verificando sessão...</div>
          ) : (
            <form onSubmit={submit}>
              <label><span>E-mail corporativo</span><input type="email" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="username" required autoFocus /></label>
              <label><span>Senha</span><input type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" required /></label>
              {error && <div className="platform-login-error" role="alert"><i className="fas fa-circle-exclamation" aria-hidden="true" />{error}</div>}
              <button type="submit" disabled={loading}>{loading ? <><i className="fas fa-spinner fa-spin" aria-hidden="true" /> Entrando...</> : <>Entrar na central <i className="fas fa-arrow-right" aria-hidden="true" /></>}</button>
            </form>
          )}
          <small className="platform-login-help">O acesso anterior é encerrado quando este usuário entra em outro dispositivo.</small>
        </section>
      </main>
    </div>
  );
}
